import React from "react";
import ReactVisibilitySensor from "react-visibility-sensor";
import {
  getVisibleSensorAnimation,
  setAdditionalClasses,
} from "../assets/js/utils";

function CustomReadMoreTitle({ title, applyClassName, h3 }) {
  return (
    <ReactVisibilitySensor partialVisibility>
      {({ isVisible }) =>
        h3 ? (
          <h3
            className={`content-sub-title${setAdditionalClasses(
              [applyClassName],
              [applyClassName]
            )}`}
            style={getVisibleSensorAnimation(
              isVisible,
              "fade-in-40px 1s backwards"
            )}
          >
            {title}
          </h3>
        ) : (
          <h2
            className={`content-sub-title${setAdditionalClasses(
              [applyClassName],
              [applyClassName]
            )}`}
            style={getVisibleSensorAnimation(
              isVisible,
              "fade-in-40px 1s backwards"
            )}
          >
            {title}
          </h2>
        )
      }
    </ReactVisibilitySensor>
  );
}

export default CustomReadMoreTitle;
